module.exports = __webpack_public_path__ + "static/media/Angelo.230b8134.png";